import {Component, ViewEncapsulation, Input, OnChanges, SimpleChanges, OnDestroy, OnInit} from '@angular/core';
import {setCulture, Browser} from '@syncfusion/ej2-base';
import {
    ILoadedEventArgs,
    ChartTheme,
    SeriesBaseModel,
    IAxisLabelRenderEventArgs, IPointRenderEventArgs, ILegendRenderEventArgs
} from '@syncfusion/ej2-angular-charts';
import {Subscription} from 'rxjs/Subscription';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {Router} from '@angular/router';

setCulture('ko');

@Component({
    selector: 'ejs-chart-component',
    templateUrl: 'ejs-chart.component.html',
    styleUrls: ['../syncfusion.custom.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EjsChartComponent implements OnInit, OnChanges, OnDestroy {
    @Input() public chartList: Array<any>;
    @Input() public chartConfig: any;
    @Input() public chartSeries: any;

    private subscription: Subscription;

    constructor(private translate: TranslateService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.setLocale();

        this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.setLocale();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    tooltipOverlap() {
        const wontTooltip = document.querySelectorAll('.ng-tooltip')[0];
        return wontTooltip.parentNode.removeChild(wontTooltip);
    }

    setLocale() {
        switch (this.translate.currentLang) {
            case 'ko':
                setCulture('ko');
                break;
            case 'en':
                setCulture('en-US');
                break;
            case 'zh':
                setCulture('zh');
                break;
            case 'ja':
                setCulture('ja');
                break;
        }
    }

    public load(args: ILoadedEventArgs): void {
        if (this.chartList.length > 1) {
            if (this.chartConfig.theme) {
                const selectedTheme = this.chartConfig.theme; // Material, Bootstrap, Highcontrast, Fabric
                args.chart.theme = <ChartTheme>(selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, 'Dark');
            }

            if (this.chartConfig.customPalettes) {
                args.chart.palettes = this.chartConfig.customPalettes;
            }
        }
    };

    public axisLabelRender(args: IAxisLabelRenderEventArgs): void {
        if (!isNaN(Number(args.text))) {
            args.text = String(Number(args.text));
        }
    };

    // custom code end
    public pointRender(args: IPointRenderEventArgs): void {
        // Bar 차트에서 개별로 색상 지정할 때 사용
        if (this.chartList.length === 1) {
            if (this.chartConfig.theme) {
                const materialColors: string[] = ['#00bdae', '#404041', '#357cd2', '#e56590', '#f8b883', '#70ad47', '#dd8abd', '#7f84e8', '#7bb4eb', '#ea7a57', '#404041', '#00bdae'];
                const fabricColors: string[] = ['#4472c4', '#ed7d31', '#ffc000', '#70ad47', '#5b9bd5', '#c1c1c1', '#6f6fe2', '#e269ae', '#9e480e', '#997300', '#4472c4', '#70ad47', '#ffc000', '#ed7d31'];
                const bootstrapColors: string[] = ['#a16ee5', '#f7ce69', '#55a5c2', '#7ddf1e', '#ff6ea6', '#7953ac', '#b99b4f', '#407c92', '#5ea716', '#b91c52'];
                const highContrastColors: string[] = ['#79ECE4', '#E98272', '#DFE6B6', '#C6E773', '#BA98FF', '#FA83C3', '#00C27A', '#43ACEF', '#D681EF', '#D8BC6E'];

                const selectedTheme = this.chartConfig.theme;

                if (selectedTheme && selectedTheme.indexOf('Fabric') > -1) {
                    args.fill = fabricColors[args.point.index % 10];
                } else if (selectedTheme.indexOf('Material') > -1) {
                    args.fill = materialColors[args.point.index % 10];
                } else if (selectedTheme.indexOf('Highcontrast') > -1) {
                    args.fill = highContrastColors[args.point.index % 10];
                } else if (selectedTheme.indexOf('Bootstrap') > -1) {
                    args.fill = bootstrapColors[args.point.index % 10];
                }
            }

            if (this.chartConfig.customPalettes) {
                const customColors: string[] = this.chartConfig.customPalettes;
                args.fill = customColors[args.point.index % this.chartConfig.customPalettes.length];
            }
        }
    };

}



// WEBPACK FOOTER //
// ./src/app/components/syncfusion/chart/ejs-chart.component.ts